import Vue from 'vue'
import ResumoService from '../domain/colegio/ResumoService'

function initialState() {
  return {
    resumos: [],
    aluno: null,
    atividade: null,
    observacao: null,
    resumoId: null
  };
}

const getResumos = (aluno) => {
  let resumoSerivce = new ResumoService(Vue.http)
  return resumoSerivce.getResumo(aluno)
    .then((resumos) => resumos)
    .catch((err) => console.log(err.message))
}

const mutations = {
  updateResumos(state, resumos) {
    state.resumos = resumos;
  },
  updateResumoId(state, resumoId) {
    state.resumoId = resumoId;
  },
  updateAluno(state, aluno) {
    state.aluno = aluno;
  },
  updateAtividade(state, atividade) {
    state.atividade = atividade;
  },
  updateObservacao(state, observacao) {
    state.observacao = observacao;
  },
  resetStore(state) {
    const s = initialState();

    Object.keys(s).forEach(function (key){
        state[key] = s[key]
    });
  }
}

const actions = {
  setResumos(state, resumos) {
    state.commit('updateResumos', resumos);
  },
  setResumoId(state, resumoId) {
    state.commit('updateResumoId', resumoId)
  },
  setAluno(state, aluno) {
    state.commit('updateAluno', aluno)
  },
  setAtividade(state, atividade) {
    state.commit('updateAtividade', atividade)
  },
  setObservacao(state, observacao) {
    state.commit('updateObservacao', observacao)
  },
  loadResumos(state) {
    getResumos(state.state.aluno, state).then((resumos) => {
      state.commit('updateResumos', resumos)
    })
  }
}

const namespaced = true;

const colegio = {
  namespaced,
  state: initialState(),
  actions,
  mutations
};

export default colegio;



// WEBPACK FOOTER //
// ./src/store/colegio.js